import * as z from "zod";
import { mutator } from "./mutator";
import { clientGeneratableIdSchema } from "../id";

export const createPersonalChatSchema = z.object({
  id: clientGeneratableIdSchema,
  chatId: clientGeneratableIdSchema,
});

export const createPersonalChat = mutator({
  schema: createPersonalChatSchema,
  resolve: {},
  permissions: {
    none: "creates a fresh chat and a personal-chat row owned by ctx.userId",
  },
  fn: async ({ tx, ctx, args }) => {
    const { id, chatId } = args;
    const { userId } = ctx;
    const now = Date.now();

    await tx.mutate.chats.insert({
      id: chatId,
      commitId: null,
      createdAt: now,
      tenantId: ctx.tenantId,
    });

    await tx.mutate.personalChats.insert({
      id,
      chatId,
      userId,
      name: "Untitled",
      createdAt: now,
      lastActiveAt: now,
      tenantId: ctx.tenantId,
    });
  },
});
